var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dish"},[_c('div',{staticClass:"top"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"cloud",attrs:{"src":`${_vm.rootUrl}/img/takumi-hirano_pa004.png`,"alt":"雲"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }